import { render } from "./UiPropTextShadow.vue?vue&type=template&id=dba6551e&scoped=true"
import script from "./UiPropTextShadow.vue?vue&type=script&lang=js"
export * from "./UiPropTextShadow.vue?vue&type=script&lang=js"

import "./UiPropTextShadow.vue?vue&type=style&index=0&id=dba6551e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba6551e"]])

export default __exports__